import styled from 'styled-components';

export const StyledChatContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  height: calc(100vh - 4rem);
  display: flex;
  flex-direction: column;
`;

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`;

export const StyledBotIcon = styled.div`
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.primary}15;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.primary};
`;

export const StyledTitle = styled.h1`
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
`;

export const StyledSubtitle = styled.p`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 0.875rem;
  margin: 0;
`;

export const StyledChatArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const StyledMessagesContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledMessage = styled.div<{ $isUser: boolean }>`
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
  ${({ $isUser }) => $isUser && 'flex-direction: row-reverse;'}
`;

export const StyledMessageIcon = styled.div<{ $isUser: boolean }>`
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: ${({ theme, $isUser }) => ($isUser ? theme.colors.primary : theme.colors.background)};
  border: 2px solid ${({ theme, $isUser }) => ($isUser ? theme.colors.primary : theme.colors.border)};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme, $isUser }) => ($isUser ? 'white' : theme.colors.textSecondary)};
  flex-shrink: 0;
`;

export const StyledMessageBubble = styled.div<{ $isUser: boolean }>`
  max-width: 70%;
  padding: 0.75rem 1rem;
  border-radius: 1rem;
  background: ${({ theme, $isUser }) => ($isUser ? theme.colors.primary : theme.colors.cardBackground)};
  color: ${({ theme, $isUser }) => ($isUser ? 'white' : theme.colors.textPrimary)};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  ${({ $isUser }) => ($isUser ? 'border-bottom-right-radius: 0.25rem;' : 'border-bottom-left-radius: 0.25rem;')}
`;

export const StyledMessageText = styled.p`
  margin: 0;
  line-height: 1.5;
  white-space: pre-wrap;
`;

export const StyledSuggestionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.75rem;
`;

export const StyledSuggestionChip = styled.button`
  padding: 0.5rem 0.75rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 1rem;
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const StyledInputContainer = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  padding: 1rem;
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.background};
`;

export const StyledInput = styled.input`
  flex: 1;
  padding: 0.75rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 1.5rem;
  background: ${({ theme }) => theme.colors.cardBackground};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: 1rem;
  outline: none;

  &::placeholder {
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;

export const StyledSendButton = styled.button`
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.primary};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.primaryHover};
  }

  &:disabled {
    background: ${({ theme }) => theme.colors.textMuted};
    cursor: not-allowed;
  }
`;

export const StyledWelcomeMessage = styled.div`
  text-align: center;
  padding: 2rem;
  color: ${({ theme }) => theme.colors.textSecondary};
`;
